import { supabase } from "@/integrations/supabase/client";
import { isHeroPhoto } from "@/seo/shared";

/** Fotos de `media/hero/` (butacas y salas), redimensionadas a 1920 px en
 *  WebP. Las usan la portada y la cabecera de /cines. */
export async function fetchHeroImages(): Promise<string[]> {
  const { data, error } = await supabase.storage
    .from("media")
    .list("hero", { sortBy: { column: "created_at", order: "desc" } });
  if (error || !data) return [];
  return data
    .filter((f) => f.metadata && (f.metadata as { size?: number }).size && isHeroPhoto(f.name))
    .map((f) => {
      // format=webp no está en los tipos del SDK, pero el endpoint de render
      // lo acepta y recorta los JPEG del hero ~45 %. Calidad 70: imperceptible.
      const { publicUrl } = supabase.storage
        .from("media")
        .getPublicUrl(`hero/${f.name}`, {
          transform: { width: 1920, quality: 70 },
        }).data;
      return `${publicUrl}&format=webp`;
    });
}

/** Índice fijo por día (días desde 1970 módulo n): la portada usa el mismo
 *  para que el prerender pueda precargarlo. `offset` da otra foto el mismo día. */
export function heroIndexForToday(n: number, offset = 0): number {
  return n ? (Math.floor(Date.now() / 864e5) + offset) % n : 0;
}

/** srcset de una foto del hero (29-10-2026): el redimensionador acepta
 *  cualquier ancho; el móvil baja la de 768 en vez de la de 1920. Mismos
 *  anchos que la precarga del prerender. */
export const HERO_WIDTHS = [768, 1280, 1920];
export const heroSrcSet = (url: string) => HERO_WIDTHS.map((w) => `${url.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(", ");
